import { styled } from "@mui/material/styles";
import {
  Stack,
  useTheme,
  useMediaQuery,
  Typography,
  Box,
  Button,
  Fade,
} from "@mui/material";
import { useShow } from "hooks/useShow";
import Grid from "@mui/material/Unstable_Grid2";
import Transitions from "components/Transitions";
import { useEffect, useMemo, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";

import okx from "assets/images/partners/okx.png";
import binance from "assets/images/partners/binance.png";
import DigiFT from "assets/images/partners/DigiFT.png";
import Gate from "assets/images/partners/gate-img.png";
import Bybit from "assets/images/partners/Bybit.png";
import Tiger from "assets/images/partners/Tiger.png";
import Mainnet from "assets/images/partners/Mainnet.png";
import Momainu from "assets/images/partners/Momainu.png";
import Ceffu from "assets/images/partners/Ceffu.png";
import Copper from "assets/images/partners/Copper.png";
import Bank from "assets/images/partners/Bank.png";
import Standard from "assets/images/partners/Standard.png";
import DMZ from "assets/images/partners/DMZ.png";
import Salus from "assets/images/partners/Salus.png";

const WapperBox = styled(Stack)`
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {},
  })};
`;

const Head = styled(Typography)`
  color: #fff;
  font-size: 46px;
  font-weight: 500;
  max-width: 500px;
  margin-top: 30px;
  line-height: 1.2;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
      marginTop: "10px",
    },
  })};
`;

const SubHead = styled(Typography)`
  color: #999;
  font-size: 18px;
  margin-top: 5px;
  font-family: KindSansRegular;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
    },
  })};
`;

const Desc = styled(Typography)`
  color: #bababa;
  font-size: 16px;
  margin-top: 20px;
  max-width: 530px;
  font-family: KindSansRegular;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "10px",
      fontSize: "12px",
    },
  })};
`;

const Containter = styled(Stack)`
  height: 100%;
  width: 1200px;
  padding: 15px 25px 150px;
  box-sizing: border-box;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "40px 20px 60px",
    },
  })};
  .swiper-slide-active {
    .img-con {
      background: linear-gradient(180deg, #1f7a55 0%, #1c332a 100%);
    }
    .name {
      color: #fff;
    }
  }
`;

const ParTabs = styled(Tabs)`
  border-top: 1px solid #3f3f3f;
  max-width: 520px;
  margin-top: 75px;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  })};
`;

const ParTab = styled(Tab)`
  color: #bababa;
  font-size: 20px;
  padding: 20px 25px;
  flex: 1;
  &.Mui-selected {
    color: #fff;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      padding: "12px 9px",
    },
  })};
`;

const RightBox = styled(Stack)`
  position: relative;
`;

const ImgCon = styled("img")`
  width: 120px;
  height: 120px;
  border-radius: 120px;
  background: #3f3f3f;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      width: "80px",
      height: "80px",
      borderRadius: "80px",
    },
  })};
`;

const NameText = styled(Typography)`
  font-size: 42px;
  color: #fff;

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "20px",
      textAlign: "center",
    },
  })};
`;

const Mask = styled(Stack)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.8),
    rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 0) 70%,
    rgba(0, 0, 0, 0.8)
  );
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      background:
        "linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 0.8))",
    },
  })};
`;

const MBox = styled(Stack)`
  margin-top: 30px;
  width: calc(100% + 40px);
  margin-left: -20px;
  height: 115px;
  position: relative;
  overflow: hidden;
`;

const Partners = () => {
  const theme = useTheme();
  const downToMd = useMediaQuery(theme.breakpoints.down("md"));
  const { ref, isShow } = useShow();
  const [value, setValue] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // const tabList = ["Exchange", "Custody", "Reserve", "Audit"];
  const tabList = ["Custody", "Reserve", "Audit"];

  const parList = [
    // [
    //   {
    //     name: "OKX",
    //     logo: okx,
    //   },
    //   {
    //     name: "Binance",
    //     logo: binance,
    //   },
    //   {
    //     name: "DigiFT",
    //     logo: DigiFT,
    //   },
    //   {
    //     name: "Gate",
    //     logo: Gate,
    //   },
    //   {
    //     name: "Bybit",
    //     logo: Bybit,
    //   },
    //   {
    //     name: "Tiger",
    //     logo: Tiger,
    //   },
    //   {
    //     name: "Mainnet",
    //     logo: Mainnet,
    //   },
    // ],
    [
      {
        name: "Komainu",
        logo: Momainu,
      },
      {
        name: "Ceffu",
        logo: Ceffu,
      },
      {
        name: "Copper",
        logo: Copper,
      },
      {
        name: "Bank Frick",
        logo: Bank,
      },
      {
        name: "Standard",
        logo: Standard,
      },
      {
        name: "Komainu",
        logo: Momainu,
      },
      {
        name: "Ceffu",
        logo: Ceffu,
      },
      {
        name: "Copper",
        logo: Copper,
      },
      {
        name: "Bank Frick",
        logo: Bank,
      },
      {
        name: "Standard",
        logo: Standard,
      },
    ],
    [
      {
        name: "DMZ",
        logo: DMZ,
      },
      {
        name: "DigiFT",
        logo: DigiFT,
      },
    ],
    [
      {
        name: "Salus",
        logo: Salus,
      },
    ],
  ];

  const curList = useMemo(() => {
    return parList[value];
  }, [value]);

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance?.update();
      swiperInstance?.autoplay?.start();
    }
  }, [curList, swiperInstance]);

  return (
    <WapperBox justifyContent="center" alignItems="center" direction="row">
      <Containter>
        <Grid
          justifyContent={downToMd ? "center" : "space-between"}
          alignItems={downToMd ? "center" : "center"}
          direction={downToMd ? "column" : "row"}
          container
          spacing={10}
          ref={ref}
        >
          <Grid xs={12} md={6}>
            <Stack>
              <Transitions delay={200} isShow={isShow}>
                <SubHead>Partners</SubHead>
              </Transitions>
              <Transitions delay={400} isShow={isShow}>
                <Head>Powerful partners driving project success</Head>
              </Transitions>
              <Transitions delay={500} isShow={isShow}>
                <Desc>
                  Our top-tier partnerships with leading exchanges, custodians,
                  and market makers provide unparalleled transparency and
                  liquidity. Security is our foremost priority. Our smart
                  contracts have undergone numerous rigorous audits by top firms
                  and we provide monthly attestations and live dashboards of
                  reserves.
                </Desc>
              </Transitions>
              <Transitions delay={600} isShow={isShow}>
                <ParTabs
                  value={value}
                  onChange={handleChange}
                  ref={ref}
                  TabIndicatorProps={{
                    sx: {
                      top: 0,
                      bottom: "auto",
                      height: "1px",
                      backgroundColor: "#fff",
                    },
                  }}
                >
                  {tabList.map((item: string, index: number) => {
                    return (
                      <ParTab
                        disableRipple
                        sx={{
                          textTransform: "none",
                        }}
                        key={index}
                        value={index}
                        label={item}
                      />
                    );
                  })}
                </ParTabs>
              </Transitions>
            </Stack>
          </Grid>
          <Grid xs={12} md={6}>
            {!downToMd && (
              <RightBox>
                <Mask />
                <Swiper
                  direction={"vertical"} // 使 Swiper 纵向滚动
                  slidesPerView={"auto"}
                  centeredSlides={true}
                  slidesPerGroup={1}
                  spaceBetween={0} // 间距
                  navigation={false} // 添加导航箭头
                  modules={[Autoplay]} // 导入模块
                  className="mySwiper"
                  onSwiper={setSwiperInstance}
                  autoplay={{
                    delay: 2000, // 2秒自动滚动
                    disableOnInteraction: false, // 用户交互后仍继续自动播放
                  }}
                  loop={true} // 适应你的布局
                  style={{
                    height: "760px",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {curList.map((item, index) => (
                    <SwiperSlide
                      key={index}
                      style={{
                        height: "auto",
                      }}
                    >
                      <Stack
                        justifyContent={"flex-start"}
                        alignItems="center"
                        direction="row"
                        my={15}
                      >
                        <ImgCon className="img-con" src={item.logo} />
                        <NameText className="name" ml={30}>
                          {item.name}
                        </NameText>
                      </Stack>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </RightBox>
            )}
            {downToMd && (
              <MBox>
                <Mask />
                <Swiper
                  direction={"horizontal"} // 使 Swiper 纵向滚动
                  slidesPerView={"auto"}
                  centeredSlides={true}
                  slidesPerGroup={1}
                  spaceBetween={0} // 间距
                  navigation={false} // 添加导航箭头
                  modules={[Autoplay]} // 导入模块
                  className="mySwiper"
                  onSwiper={setSwiperInstance}
                  autoplay={{
                    delay: 2000, // 2秒自动滚动
                    disableOnInteraction: false, // 用户交互后仍继续自动播放
                  }}
                  loop={true} // 适应你的布局
                  style={{
                    height: "115px",
                    width: "100%",
                  }}
                >
                  {curList.map((item, index) => (
                    <SwiperSlide
                      key={index}
                      style={{
                        height: "auto",
                        width: "100px",
                      }}
                    >
                      <Stack
                        justifyContent={"center"}
                        alignItems="flex-start"
                        direction="row"
                        mx={20}
                        width={80}
                      >
                        <Box>
                          <ImgCon className="img-con" src={item.logo} />
                          <NameText className="name">{item.name}</NameText>
                        </Box>
                      </Stack>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </MBox>
            )}
          </Grid>
        </Grid>
      </Containter>
    </WapperBox>
  );
};

export default Partners;
